module.exports = "<div class=\"modal-header\">\r\n    <label>{{titulo}}</label>\r\n</div>\r\n\r\n<div class=\"modal-body\">\r\n    <label class=\"col-form-label-sm\">{{mensaje1}} &nbsp; {{mensaje3}} &nbsp;{{mensaje2}}</label>\r\n</div>\r\n\r\n<div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-light\"  (click)=\"closeModal('cancelar')\">\r\n                {{'texto.aceptarLabel' | translate}}\r\n        </button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/response-modal2/response-modal2.component.html
// module id = ./src/app/components/response-modal2/response-modal2.component.html
// module chunks = main